import React from "react";
import Button from "../../../shared/Button";
import { klaviyoHandleClientData } from "../../../../services/klaviyo";
import { ClientAction } from "../../../../store/order";

export interface IKlaviyoTriggerForm {
    klaviyoFormId: string;
    buttonLabel: string;
}

const KlaviyoTriggerForm = ({ data }: { data: IKlaviyoTriggerForm }) => {

    const handleButtonClick = async () => {

        await klaviyoHandleClientData({
            action: ClientAction.openForm,
            parsed: {
                buttonText: data.buttonLabel,
                formId: data.klaviyoFormId
            }
        });
    };

    return (
        <Button onClick={handleButtonClick}>
            {data.buttonLabel}
        </Button>
    );
};

export default KlaviyoTriggerForm;
